import { createContext, ReactNode, useState } from 'react';

import { CommentHighlightProvider } from '@vimeo/comments-ui';

import { usePrivateComments } from '../hooks/comments/use-get-comments';

export type PrivateComment = ReturnType<typeof usePrivateComments>['comments'][number];

const noopFunc = () => new Error('Not implemented');

type CommentsContextType = {
  comments: PrivateComment[];
  setComments: (comments: PrivateComment[]) => void;
  activeComment?: PrivateComment;
  setActiveComment: (comment?: PrivateComment) => void;
  isCommentsShowing: boolean;
  setIsCommentsShowing: (isShowing: boolean) => void;
  commentAnnotationFormShown: boolean;
  setCommentAnnotationFormShown: (annotationsFormShown: boolean) => void;
};

export const CommentsContext = createContext<CommentsContextType>({
  comments: [],
  setComments: noopFunc,
  setActiveComment: noopFunc,
  isCommentsShowing: false,
  setIsCommentsShowing: noopFunc,
  commentAnnotationFormShown: false,
  setCommentAnnotationFormShown: noopFunc,
});

export const CommentContextProvider = (props: { children: ReactNode }) => {
  const [comments, setComments] = useState<PrivateComment[]>([]);
  const [activeComment, setActiveComment] = useState<PrivateComment>();
  const [isCommentsShowing, setIsCommentsShowing] = useState<boolean>(false);
  const [commentAnnotationFormShown, setCommentAnnotationFormShown] = useState(false);

  const contextValue = {
    comments,
    setComments,
    activeComment,
    setActiveComment,
    isCommentsShowing,
    setIsCommentsShowing,
    commentAnnotationFormShown,
    setCommentAnnotationFormShown,
  };

  return (
    <CommentHighlightProvider>
      <CommentsContext.Provider value={contextValue}>{props.children}</CommentsContext.Provider>
    </CommentHighlightProvider>
  );
};
